import { gql } from '@provision/graphql-client';

export const SIGNAL_BUSINESS_HOURS_FRAGMENT = gql`
  fragment SignalBusinessHoursFields on SignalBusinessHours {
    __typename
    id
    signalBusinessHoursId
    timeFrom
    timeTo
    urgency
    weekDay
    partnerId
    createdAt
  }
`;
